module.exports = __webpack_public_path__ + "static/media/DocWithSampleLarge.06a377b9.png";